import React from 'react';

import Odnosnik from './Zanimowane/Odnosnik';

const OpadajacaStrona = ({ isVisible}) => {


  return (
    <div
      className={`fixed top-0 left-0 w-full h-full bg-gradient-to-t from-[#28538b] from-20% to-red-500 transition-all duration-1000 ease-in-out transform ${
        isVisible ? 'translate-y-0' : '-translate-y-full'
      } z-20`}
    >
      <div
        className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col justify-between space-y-[1rem] text-center ${
          isVisible ? '' : 'hidden'
        }`}
      >
        <Odnosnik tekst={"HOME"} link={"/portfolio/"}/>
        <Odnosnik tekst={"PROJECTS"} link={"/portfolio/projects"}/>
        <Odnosnik tekst={`ABOUT ME`} link={"/portfolio/about"}/>
        <Odnosnik tekst={"BLOG"} link={"https://destray32.github.io/ml-blog/"}/>
        {/* <Odnosnik tekst={"SERCE"} link={"/portfolio/serce"}/> */}
      </div>
    </div>
  );
};

export default OpadajacaStrona;


